theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };
  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };
  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  var libraries = {
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };
  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (!library) return;
    if (library.status === status.requested) return;
    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }
    library.status = status.requested;
    var tag;
    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }
    tag.id = library.tagId;
    library.element = tag;
    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  return {
    load: load
  };
})();

function VariantHelper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function VariantHelper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function VariantHelper_createClass(Constructor, protoProps, staticProps) { if (protoProps) VariantHelper_defineProperties(Constructor.prototype, protoProps); if (staticProps) VariantHelper_defineProperties(Constructor, staticProps); return Constructor; }
var VariantHelper = function () {
  function VariantHelper(theme_pJ, product, $form) {
    VariantHelper_classCallCheck(this, VariantHelper);
    var _this = this;
    this.product = product;
    this.optionsCount = this.product.options.length;
    if (theme_pJ.option_type == null) {
      return;
    }    
    this.$form = $form;
    this.theme_pJ = theme_pJ;
    this.optionsTypes = {
      select: 'select',
      radio: 'radio'
    };
    this._bindEvents();
    if (theme_pJ.variant_type === this.optionsTypes.radio) {
      this.optionsType = this.optionsTypes.radio;
    } else {
      this.optionsType = this.optionsTypes.select;
    }
    this._switchVariant(true);
    if (this.optionsType === this.optionsTypes.radio) {
      Swatches(this.$form);      
    };
  }
  VariantHelper_createClass(VariantHelper, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;
      const dpo = _this.$form.querySelector('[data-product-options]'),
            varID = _this.$form.querySelector('[name="id"]');
      const handleChange = (o) => {
        if (!theme.thumbID) {
          if (_this.optionsType === _this.optionsTypes.radio) {
            varID.value = o.target.dataset.variantId;
          } else {
            varID.value = o.target.options[o.target.selectedIndex].dataset.variantId;
          }          
        }
        document.dispatchEvent(new CustomEvent('_changeVariant', {
          bubbles: true
        }));
        return _this._switchVariant(o);
      };
      theme.time = 0;
      dpo.addEventListener('keydown', (e) => {
        const focusedElement = document.activeElement;
        if (dpo.contains(focusedElement)) {
          switch (e.key) {
            case 'ArrowUp':
              theme.time = 500;
              break;
            case 'ArrowDown':
              theme.time = 500;
              break;
            case 'ArrowLeft':
              theme.time = 500;
              break;
            case 'ArrowRight':
              theme.time = 500;
              break;
          }
        }
      });
      const debouncedHandleChange = theme.Helpers.debounce(handleChange, theme.time);      
      dpo.addEventListener('change', debouncedHandleChange);
    }
  }, {
    key: "_switchVariant",
    value: function _switchVariant(f, force) {
      var _this = this,
          firstLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false,
          product = this.product,
          variant = null;
      var isProduct = function isProduct(compareProduct) {
        return compareProduct === product;
      };
      let event = new CustomEvent('product-variant-switch', {
        detail: {
          product: product,
          variant: variant,
          firstLoad: firstLoad,
          isProduct: isProduct,
          theme_pJ: this.theme_pJ
        }
      });
      this.$form.dispatchEvent(event);        
    }
  }]);
  return VariantHelper;
}();

function ProductForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductForm_defineProperties(Constructor, staticProps); return Constructor; }
var ProductForm = function () {
  function ProductForm(el) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ProductForm_classCallCheck(this, ProductForm);
    this.$el = options.container || el;
    this.$form = options.form || el;
    this.options = options;
    this.product = options.product;
    this.product.options = options.productVariants;
    this.postMessage = this.options.postMessage;
    this.isThemeEditor = Shopify && Shopify.designMode;
    this.useHistory = options.useHistory && !this.isThemeEditor && window.history && history.replaceState;
    this.events = [];
    Cart(options.productEl);
    this.events.push(
      this.$form.addEventListener('product-variant-switch', function(event, data) {
        var data = event.detail;
        _this._changeVariant(data);
      })
    )
    this.variantHelper = new VariantHelper(this.options.theme_pJ, this.options.product, this.$form);
  }
  ProductForm_createClass(ProductForm, [{
    key: "unload",
    value: function unload() {      
    }
  }, {
    key: "_changeVariant",
    value: function _changeVariant(data) {
      this._changeUrl();
    }
  }, {
    key: "_changeUrl",
    value: function _changeUrl(variant) {
      if (!this.useHistory) {
        return;
      }
      p = {
        variant: this.$form.querySelector('[name="id"]').value
      }
      params = Object.keys(p).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(p[k])
      }).join('&');
      var url = "".concat(this.options.product.handle, "?").concat(params);
      history.replaceState({}, 'variant', url);
    }
  }]);
  return ProductForm;
}();

function ProductZoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductZoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductZoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductZoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductZoom_defineProperties(Constructor, staticProps); return Constructor; }
var ProductZoom = function () {
  function ProductZoom(el) {
    var _this = this;
    ProductZoom_classCallCheck(this, ProductZoom);
    this.el = el;
    this.$el = el;
    this.$img = this.$el.querySelector('img');
    this.scale = this.$img.getAttribute('width') / this.$el.getBoundingClientRect().width;
    this.zoomable = this.scale >= 1.25;
    this.framerate = 60;
    this.zoomed = false;
    this.resetZoom = this._resetZoom.bind(this);
    this._init();
    this.$img.addEventListener('img:load', _this._init());
  }
  ProductZoom_createClass(ProductZoom, [{
    key: "_init",
    value: function _init() {
      this.disableZoom();
      if (this.zoomable) {
        this.enableZoom();        
      }
    }
  }, {
    key: "enableZoom",
    value: function enableZoom() {
      this.$el.classList.add('product-image-zoomable');
      this._bindEvents();
    }
  }, {
    key: "disableZoom",
    value: function disableZoom() {
      this.$el.classList.remove('product-image-zoomable');
      this._resetZoom();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;
      this.$el.onclick = function(event){
        _this2._toggleZoom(event.clientX, event.clientY);
      };
      window.onresize = function(event){
        this.resetZoom
      };
    }
  }, {
    key: "_toggleZoom",
    value: function _toggleZoom(clientX, clientY) {
      var _this3 = this;
      if (!theme.mobile && theme.dragging) return;      
      if (!this.zoomed) {
        this.$img.srcset = this.$img.getAttribute('data-zoom');        
        if (theme.detectmob) {
          this.$el.ontouchcancel = function(){
            _this3._resetZoom();
            return
          };
          document.body.classList.add('zoom-enabled');
          if (this.$el.closest('.glider')) {
            this.$el.closest('.glider').classList.add('no-drag');
          };
          this.$el.ontouchmove = theme.Helpers.debounce(function (event) {
            var touch = event.touches[0];
            _this3._positionZoom(touch.clientX, touch.clientY);
          }, 100 / this.framerate, true, true);
        } else {
          this.$el.onmouseout = function(){
            _this3._resetZoom();
            return
          };
          this.$el.onmousemove = theme.Helpers.debounce(function (event) {
            _this3._positionZoom(event.clientX, event.clientY);
          }, 100 / this.framerate, true, true);        
        }          
        this.$el.classList.add('product-image-zoomed');          
        this.$img.style.transform = 'scale(' + this.scale + ')';
        this._positionZoom(clientX, clientY);
        this.zoomed = true;
      } else {
        this._resetZoom();
      }
    }
  }, {
    key: "_resetZoom",
    value: function _resetZoom() {
      this.$el.ontouchend = null;
      this.$el.ontouchmove = null;
      this.$el.onmousemove = null;
      this.$el.onmouseout = null;
      if (theme.detectmob) {
        document.body.classList.remove('zoom-enabled');
        if (this.$el.closest('.glider')) {
          this.$el.closest('.glider').classList.remove('no-drag');
        };
      }
      this.$el.classList.remove('product-image-zoomed');
      this.$img.style.removeProperty('transform');
      this.zoomed = false;
    }
  }, {
    key: "_positionZoom",
    value: function _positionZoom(clientX, clientY) {
      if (!this.zoomed) {
        return;
      }
      var figRect = this.$el.getBoundingClientRect(),
          imgRect = this.$img.getBoundingClientRect(),
          figHalfWidth = figRect.width / 2,
          figHalfHeight = figRect.height / 2,
          centerX = figRect.left + figHalfWidth,
          centerY = figRect.top + figHalfHeight,
          widthDiff = imgRect.width / 2 - figHalfWidth,
          heightDiff = imgRect.height / 2 - figHalfHeight,
          translateX = (centerX - clientX) / figHalfWidth * widthDiff / this.scale,
          translateY = (centerY - clientY) / figHalfHeight * heightDiff / this.scale;
      this.$img.style.transform = "scale(" .concat(this.scale, ") translate(").concat(translateX, "px, ").concat(translateY, "px)");
    }
  }]);
  return ProductZoom;
}();

function ProductGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGallery_defineProperties(Constructor, staticProps); return Constructor; }
var ProductGallery = function () {
  function ProductGallery(el) {      
    var _this = this,
        settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ProductGallery_classCallCheck(this, ProductGallery);
    this.el = el;      
    this.settings = settings;
    var sectionId = this.settings.section.id;
    this.viewport = this.el.querySelector('#main-product-image-' + sectionId);  
    this.featured = this.el.querySelector('#featured-' + sectionId);
    this.navigation = this.el.querySelector('#thumbnails-' + sectionId);
    this.thumbnails = this.el.querySelectorAll('.thumbnails-' + sectionId + ' .button');
    this.figures = this.viewport.querySelectorAll('figure');
    this.selected = {
      figure: this.viewport.querySelector('figure.visible'),
      thumbnail: null
    };
    this.media = {
      images: [],
      models: [],
      videos: []
    };
    var variantImages = {},
        thumbnails,
        variantImage,
        opt_key,
        opt_val,
        loop_index,
        vars = settings.section.data.product_info.variants,
        opts = settings.section.data.product_info.options,
        selector = settings.section.el.querySelector('[data-product-options]'),
        options = settings.section.el.querySelectorAll('.selector-option:not([data-product-url])'),
        optionsTypes = {
          select: 'select',
          radio: 'radio'
        };
    function vChange(image) {
      opts.forEach(function(o,i) {
        loop_index = 'option-' + i;
        if (variantImages[image][loop_index] !== null) {
          var index = i;
          options.forEach(function (o) {
            if (o.value == variantImages[image][loop_index]) {
              o.checked = true;
              theme.thumbID = true;
              theme.thumbVAR = o;
              document.getElementById('variantId-' + section.id).value = o.dataset.variantId;
              _this.el.closest('section').querySelector('[name="id"]').value = o.dataset.variantId;
              selector.dispatchEvent(new Event('change'));              
            }
            return
          });
        }
      });
    }
    if (this.featured) {
      this.slideshow = true;
      this.slideshow_section = false;      
      var FCarousel = document.getElementById('featured-'+ sectionId);      
      if (FCarousel) {
        this.active = this.featured.querySelector('.active .media-container');
        this.fthumbnails = this.viewport.querySelectorAll('.thumbs');
        this.imageHeight(this.active);
        var mSI = FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'),
            next = document.getElementById('glider-featured-button-next-thumbs-' + sectionId),
            prev = document.getElementById('glider-featured-button-prev-thumbs-' + sectionId),
            glider = new Glider(FCarousel, {
              arrows: {
                prev: prev,
                next: next
              },
              draggable: true,
              rewind: true,
              scrollLock: true,
              skipTrack: true,
              slidesToShow: 1,
              slidesToScroll: 1
            });
        if (glider) {
          FCarousel.querySelector('.glider-track.slideshow').classList.add('loaded');
          // This is an initention dup to avoid the initial slide when loading a variant that is not the first
          Glider(this.featured).scrollItem(parseInt(mSI));
          Glider(this.featured).scrollItem(parseInt(mSI));
          FCarousel.addEventListener('glider-slide-visible', function(ev) {
            if (theme.busy) {
              _this.fthumbnails.forEach(function (t) {
                t.disabled = true;
              });
              return;
            } else {
              setTimeout(function() {
                theme.busy = false;
                _this.fthumbnails.forEach(function (t) {
                  t.disabled = false;
                });
              }, 350);
            }
            theme.busy = true;            
            if (theme.thumb) {
              theme.thumb = false;
              return;
            }            
            var featured = FCarousel.querySelector('.active img[src]');
            if (featured) {
              var image = featured.getAttribute('src').split('?')[0].replace(/(_1x)/,'');
              if (typeof variantImages[image] !== 'undefined') {
                if (theme.featuredDragging) {
                  theme.featuredDragging = false;
                  vChange(image);
                }
              } else {
                _this._selectMediaByIndex(FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'));
              };
            } else {
              _this._selectMediaByIndex(FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'));              
            };            
          });
        }
      };
      var resizeTimer;
      window.addEventListener('resize', function(b) {
        if (cW == window.innerWidth) {
          return;
        }
        cW = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          _this.imageHeight(_this.active);
        }, 250);
      });
    }
    if (this.navigation) {
      this.selected.thumbnail = this.navigation.querySelector('[data-product-gallery-selected="true"]');
      this.slideshow = true;
      this.slideshow_section = false;
      var TCarousel = document.getElementById('thumbnails-'+ sectionId);  
      if (TCarousel) {
        var mSI = this.selected.thumbnail.getAttribute('data-product-gallery-thumbnail'),
            next = document.getElementById('glider-button-next-thumbs-' + sectionId),
            prev = document.getElementById('glider-button-prev-thumbs-' + sectionId),
            glider = new Glider(TCarousel, {
              arrows: {
                prev: prev,
                next: next
              },
              draggable: true,
              dragVelocity:2.5,
              resizeLock: false,
              skipTrack: true, 
              slidesToShow: 4,
              slidesToScroll: 4
            });
        if (glider) {
          Glider(this.navigation).scrollItem(parseInt(mSI));
          TCarousel.classList.add('loaded');
        }
      };
    }
    vars.forEach(function(v) {
      variant = v;
      if ( typeof variant.featured_image !== 'undefined' && variant.featured_image !== null ) {
        variantImage =  variant.featured_image.src.split('?')[0].replace(/http(s)?:/,'');
        variantImages[variantImage] = variantImages[variantImage] || {};
        var opts = v.options
        opts.forEach(function(o,i) {
          opt_key = 'option-'+i;
          opt_val = o;
          if (typeof variantImages[variantImage][opt_key] === 'undefined') {
            variantImages[variantImage][opt_key] = opt_val;
          }
          else {
            var oldValue = variantImages[variantImage][opt_key];
            if ( oldValue !== null && oldValue !== opt_val )  {
              variantImages[variantImage][opt_key] = null;
            }
          }
        });
      }
    });
    this.thumbnails.forEach(function (thumbnail) {
      var _this2 = this;
      thumbnail.onclick = function(e){
        theme.thumb = true;
        var thumb = this.querySelector('img[src]'),
            image = thumb.getAttribute('src').split('?')[0].replace(/(_1x)/,'');
        if (typeof variantImages[image] !== 'undefined') {
          vChange(image);
        } else {
          _this._selectMediaByIndex(this.getAttribute('data-product-gallery-thumbnail'));          
        }
      }
    });
    var features = [];
    if (this.settings.zoom_enable && this.selected.figure.dataset.mediaType === 'image') {
      this._initZoom(this.selected.figure);
    }
    if (this.el.querySelector('[data-media-type="model"]')) {
      this.viewport.onclick = function(e){
        if ('shopifyXr' in e.target.dataset) {
          _this._onViewInYourSpaceClick(e.target);
        }
      };
      features.push({
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this._onModelLibraryLoad.bind(this)
      });
      features.push({
        name: 'shopify-xr',
        version: '1.0'
      });      
    }
    if (this.el.querySelector('[data-media-type="video"]')) {
      Promise.all([new Promise(function (resolve) {
        if (!document.querySelector('#plyr-stylesheet')) {
          var link = document.createElement('link');
          link.setAttribute('id', 'plyr-stylesheet');
          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('href', 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');
          link.onload = resolve;
          document.body.appendChild(link);
        } else {
          resolve();
        }
      }), new Promise(function (resolve) {
        features.push({
          name: 'video-ui',
          version: '1.0',
          onLoad: resolve
        });
      })]).then(this._onVideoLibraryLoad.bind(this));
    }
    if (features.length) {
      Shopify.loadFeatures(features);
    }
  }
  ProductGallery_createClass(ProductGallery, [{
    key: "imageHeight",
    value: function imageHeight(a) {
      var newHeight = a.offsetHeight;
      this.featured.querySelector('.glider-track').style.height = newHeight + 'px';      
    }
  }, {
    key: "selectMediaByVariant",
    value: function selectMediaByVariant(t) {        
      if (t.dataset.variantImg) {
        var figure = this.viewport.querySelector("[data-media=\"".concat(t.dataset.variantImg, "\"]"));
      } else {
        var figure = this.viewport.querySelector("[data-product-gallery-figure='0']");
      }
      if (!figure) return;
      this._selectMediaByIndex(figure.dataset.productGalleryFigure);          
    }
  }, {
    key: "pauseVideos",
    value: function pauseVideos() {
      this.el.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      this.el.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      var excludeVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.media.videos.forEach(function (v) {
        if (v !== excludeVideo) {
          v.figure.querySelector('.plyr').tabIndex = -1;
          v.pause();
        }
      });
    }
  }, {
    key: "pauseModels",
    value: function pauseModels() {
      var excludeModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.media.models.forEach(function (m) {
        if (m !== excludeModel && m.ui.interacting) {
          m.ui.pause();
        }
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.events.unregisterAll();
      this.media.videos.forEach(function (v) {
        return v.unload();
      });
      this.media.images.forEach(function (i) {
        return i.unload();
      });
    }
  }, {
    key: "_onModelLibraryLoad",
    value: function _onModelLibraryLoad() {
      var _this2 = this,
          controls = ['zoom-in', 'zoom-out'];      
      theme.LibraryLoader.load('modelViewerUiStyles');
      if (document.fullscreenEnabled) controls.push('fullscreen');
      this.viewport.querySelectorAll('[data-media-type="model"]').forEach(function (modelFigure) {
        var modelEl = modelFigure.querySelector('model-viewer');
        _this2.media.models.push({
          ui: new Shopify.ModelViewerUI(modelEl, {
            controls: controls
          }),
          el: modelEl,
          figure: modelFigure
        });
        modelEl.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
          _this2.viewport.querySelector('.glider').classList.add('no-drag');
          theme.model = true;
        }.bind(this));
        modelEl.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
          _this2.viewport.querySelector('.glider').classList.remove('no-drag');
          theme.model = false;
        }.bind(this));
      });
    }
  }, {
    key: "_onViewInYourSpaceClick",
    value: function _onViewInYourSpaceClick(target) {
      if (target.dataset.shopifyModel3dId === this.selected.figure.dataset.media) return;
      var figure = this.viewport.querySelector("[data-media=\"".concat(target.dataset.shopifyModel3dId, "\"]"));
      this._selectMediaByEl(figure);
    }
  }, {
    key: "_selectMediaByEl",
    value: function _selectMediaByEl(el) {
      this._selectMediaByIndex(parseInt(el.dataset.productGalleryFigure, 10));
    }
  }, {
    key: "_onVideoLibraryLoad",
    value: function _onVideoLibraryLoad() {      
      var _this3 = this,
          videoFigures = this.viewport.querySelectorAll('[data-media-type="video"]'),
          _loop = function _loop(i) {
        var videoFigure = videoFigures[i],
            videoEl = videoFigure.querySelector('video'),
            player = new Shopify.Plyr(videoEl, {
          loop: {
            active: _this3.settings.loop_enable
          }
        });
        var video = {
          figure: videoFigure,
          el: videoEl,
          player: player,
          restart: function restart() {
            player.restart();
            player.play();
          },
          pause: function pause() {
            return player.pause();
          },
          play: function play() {
            return player.play();
          },
          unload: function unload() {
            return player.destroy();
          }
        };
        videoFigure.play = function(e){
          return _this3.pauseVideos(video);
        }        
        _this3.media.videos.push(video);
      };
      for (var i = 0; i < videoFigures.length; i++) {
        _loop(i);
      }
      videoFigures.forEach(function(v) {
        v.querySelector('.plyr').tabIndex = -1;
      });
    }
  }, {
    key: "_onVideoSelect",
    value: function _onVideoSelect(video) {
      video.figure.querySelector('.plyr').tabIndex = 0;
      if (!theme.detectmob) {
        video.play();
      }
    }
  }, {
    key: "_onMediaSelect",
    value: function _onMediaSelect(index) {
      var _this8 = this,
          focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false,
          figure = this.figures[index];
      this.selected.figure.dataset.productGallerySelected = false;
      this.selected.figure.tabIndex = -1;
      this.selected.figure = figure;
      this.selected.figure.dataset.productGallerySelected = true;
      this.selected.figure.tabIndex = 0;
      var viewInYourSpaceEls = this.el.querySelectorAll('[data-shopify-xr]'),
          setViewInYourSpaceID = function setViewInYourSpaceID(id) {
        for (var i = 0; i < viewInYourSpaceEls.length; i++) {
          viewInYourSpaceEls[i].dataset.shopifyModel3dId = id;            
        }
      };
      if (viewInYourSpaceEls.length) {
        setViewInYourSpaceID(viewInYourSpaceEls[0].dataset.defaultModelId);
      }
      this.pauseVideos();
      this.pauseModels();
      this.media.models.forEach(function (m) {
        if (m.figure === _this8.selected.figure) {
          if (!theme.detectmob) {
            m.ui.play();
          }
        }
      });
      switch (this.selected.figure.dataset.mediaType) {
        case 'external_video':
          let f = this.selected.figure;
          if (!f.getAttribute('loaded') && f.querySelector('template')) {
            f.querySelector('.youtube-container').appendChild(f.querySelector('template').content.firstElementChild.cloneNode(true));
            f.setAttribute('loaded', true);
          }
          f.focus();
          break;
        case 'video':          
          let v = this.selected.figure;
          if (v.classList.contains('visible-video')) {
            v.classList.remove('visible-video')
          } else {
            this._onVideoSelect(this.media.videos.filter(function (v) {
              return v.figure === _this8.selected.figure;
            })[0]);
          }          
          break;
        case 'model':
          setViewInYourSpaceID(this.selected.figure.dataset.media);
          break;
        case 'image':
          if (this.settings.zoom_enable && this.selected.figure.dataset.mediaType === 'image') {
            this._initZoom(this.selected.figure);
          };
          break;
        default:
          break;
      }
    }
  }, {
    key: "_selectMediaByIndex",
    value: function _selectMediaByIndex(index) {
      var _this = this,
          focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false,
          mSI = index;
      if (this.featured) {
        Glider(this.featured).scrollItem(parseInt(mSI));        
        setTimeout(function() {
          _this.imageHeight(_this.featured.querySelector('[data-product-gallery-figure="' + mSI + '"] .media-container'));
        }, 250);
      }
      if (this.navigation) {
        Glider(this.navigation).scrollItem(parseInt(mSI));
        var thumbnail = this.thumbnails[index];
        if (this.selected.thumbnail) {
          this.selected.thumbnail.dataset.productGallerySelected = false;
        }
        this.selected.thumbnail = thumbnail;
        this.selected.thumbnail.dataset.productGallerySelected = true;
      }
      _this._onMediaSelect(index, focus);
    }
  }, {
    key: "_initZoom",
    value: function _initZoom(figure) {
      var exists = this.media.images.filter(function (image) {
        return image.el.dataset.media === figure.dataset.media;
      });
      if (this.media.images.length === 0 || exists.length === 0) {
        this.media.images.push(new ProductZoom(figure));
      }
    }
  }]);
  return ProductGallery;
}();

function StoreAvailabilityLoad (theme_pJ, container) {  
  var sectionId = container.getAttribute('data-section-id'),
      sectionType = container.getAttribute('data-section-type');
  if (!theme_pJ) {
    return;
  }
  this.container = container;
  var sectionId = container.getAttribute('data-section-id');
  this.selectors = {
    storeAvailabilityContainer: '[data-store-availability-container]',
    originalSelectorId: '#product-select-' + sectionId,
    singleOptionSelector: 'form.product-form-' + sectionId + ' .single-option-selector'
  };
  this.storeAvailabilityContainer = container.querySelector(
    this.selectors.storeAvailabilityContainer
  );
  if (this.storeAvailabilityContainer) {
    this.storeAvailability = new StoreAvailability(this.storeAvailabilityContainer);
  }
  if (this.storeAvailability) {
    this.storeAvailability.updateContent(
      container.querySelector('[name="id"]').value,
      theme_pJ.product_info.title
    );
  }  
};

StoreAvailability = (function(container) {
  var selectors = {
    storeAvailabilityModalProductTitle: '[data-store-availability-modal-product-title]'
  };
  function StoreAvailability(container) {
    this.container = container;
    this.sectionId = this.container.getAttribute('data-section-id');
    this.pT = this.container.dataset.productTitle;
  }
  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId) {
      let baseUrl = this.container.dataset.baseUrl;
      if (!baseUrl.endsWith('/')) {
        baseUrl = baseUrl + '/';
      }
      var variantSectionUrl =
          baseUrl +
          'variants/' +
          variantId +
          '/?section_id=store-availability';
      var self = this;
      fetch(variantSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(storeAvailabilityHTML) {
        if (storeAvailabilityHTML.trim() === '') {
          return;
        }
        self.container.innerHTML = storeAvailabilityHTML;
        self.container.innerHTML = self.container.firstElementChild.innerHTML;
        var storeAvailabilityModalProductTitle = self.container.querySelector(
          selectors.storeAvailabilityModalProductTitle
        );
        if (storeAvailabilityModalProductTitle) {
          storeAvailabilityModalProductTitle.textContent = self.pT;
        }
        var el = self.container.querySelector('.srfc');        
        const body = document.body;
        const content = self.container.querySelector('.StoreAvailabilityModal');
        if (!el) return;
        const m = document.querySelector('#avail-' + variantId);
        const mc = content.querySelector('.modal-container');
        const aB = document.getElementById('ajaxBusy');
        el.onclick = (e) => {          
          try {
            MicroModal.show('avail-' + variantId, {
              onShow: function(modal) {
                m.classList.add('loaded');
                mc.classList.add('loaded');
                aB.style.display = 'block';
                document.body.classList.add('modal-active');
              },
              onClose: function(modal) {
                setTimeout(function() {
                  m.classList.remove('loaded');
                  document.body.classList.remove('modal-active');
                }, 250);
                mc.classList.remove('loaded');
                aB.style.display = 'none';
              }
            });
          } catch (e) {
            console.log("micromodal error: ", e);
          }
          e.preventDefault();
        }
      });
    },
  });
  return StoreAvailability;
})();

function Tooltip(container) {  
  var el = container.querySelectorAll('.tooltip'),
      m = document.querySelector('#quick-modal'),
      mc = m.querySelector('.modal-container'),
      mcC = mc.querySelector('.modal-content'), 
      aB = document.getElementById('ajaxBusy');
  el.forEach(function(e) {
    e.onclick = function(ev){      
      const content = this.getAttribute('data-container'),
            content_container = this.parentNode;
      e.focus();
      aB.style.display = 'block';
      const section = JSON.parse(content_container.querySelector('.' + content).innerText);
      MicroModal.show('quick-modal', {
        onShow: function(modal) {
          m.classList.add('loaded');
          mc.classList.add('loaded');
          document.body.classList.add('modal-active');
        },
        onClose: function(modal) {              
          setTimeout(function() {
            m.classList.remove('loaded');
            document.body.classList.remove('modal-active');            
            mcC.innerHTML = '';            
          }, 250);
          mc.classList.remove('loaded');
          aB.style.display = 'none';
        }
      });    
      m.classList.add('loaded');
      mcC.innerHTML = section;
    };
  });
};

function VariantLoad(section, form, product, vLoad, ID) {
  var dPO = form.querySelectorAll('[data-product-options] .selector-option:not([data-product-url])');
  function removeClass() {
    form.classList.remove('disabled');
  };
  const removeFormClass = theme.Helpers.debounce(removeClass, 100);
  if (dPO.length > 0) {    
      function addUniqueObject(newObject) {
      const isDuplicate = vLoad.some(item => item.id === newObject.id);
      if (!isDuplicate) {
        vLoad.push(newObject);
        removeFormClass();
      }
    }
    dPO.forEach(function(d) {
      fetch(section.data.product_url + '?variant=' + d.dataset.variantId + '&section_id=' + ID)
      .then(function(r) {
        return r.text();
      }).then(function(j) {
        const htmlDocument = new DOMParser().parseFromString(j, 'text/html');
        var blocks = [];
        htmlDocument.querySelectorAll('.variant_reload').forEach(function(v,i) {
          var nV = v.getAttribute('id'),
              block = htmlDocument.querySelector('#' + nV);            
          if (!block) {
            return;
          }
          blocks.push(block)
        });
        addUniqueObject({ id: d.dataset.variantId, blocks });
      }).catch(function(err) {
        console.error('!: ' + err)
      });
    });
  } else {
    removeFormClass();
  }
  GPOConfigs?.initialize?.();
}

function ProductDetails_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductDetails_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductDetails_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductDetails_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductDetails_defineProperties(Constructor, staticProps); return Constructor; }
var ProductDetails = function () {
  function ProductDetails(_ref, force) {
    var _this = this,
        $el = _ref.$el,
        section = _ref.section;
    ProductDetails_classCallCheck(this, ProductDetails);
    this.el = $el;
    this.section = section;
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.postMessage = section.postMessage;
    this.type = section.type;
    this.$el = $el;
    this.$window = window;
    this.varID = document.getElementById('variantId-' + section.id).value;
    this.$productInfo = $el.querySelector('#product-details-' + section.id);
    this.$atc = $el.querySelector('#add-to-cart-' + section.id);
    this.$vars = $el.querySelector('[data-product-options]');
    if (!this.$vars) {
      $el.querySelector('[data-product-form]').classList.remove('disabled');
    }
    this._handleVariantChange = this._handleVariantChange.bind(this);
    if (this.el.querySelector('.product-images')) {
      this.productGallery = new ProductGallery(this.el.querySelector('.product-images'), {
        loop_enable: this.data.loop_enable,
        zoom_enable: this.data.zoom_enable,
        section: section
      });
    }
    this.listeningForVariantChange = false;
    this.listenForVariantChange();
    if (!this.onboarding) {
      this.form = new ProductForm(this.$productInfo, {        
        form: this.$el.querySelector('[data-product-form]'),
        productEl: this.$el,
        theme_pJ: _ref.theme_pJ,
        product: this.data.product_info,
        productVariants: this.data.product_variants,
        type: this.type,
        moneyFormat: theme.moneyFormat,
        postMessage: section.postMessage,
        useHistory: this.data.use_history
      });
    }
    Quantity(this.$el);
    if (this.$el.querySelector('.product-single__store-availability-container')) {
      StoreAvailabilityLoad(_ref.theme_pJ, this.$el);
    }    
    Tooltip(this.$el);
    var pg = $el.querySelector('.product-gift-' + section.id);
    if (pg) {
      var i = pg.querySelector('input[type="checkbox"]'),
          d = pg.querySelector('details');
      i.onchange = function(ev){
        d.toggleAttribute('open')
      }
    }
  }
  ProductDetails_createClass(ProductDetails, [{
    key: "listenForVariantChange",
    value: function listenForVariantChange() {
      if (!this.listeningForVariantChange) {
        this.$el.querySelector('[data-product-form]').addEventListener('product-variant-switch', this._handleVariantChange);
        this.listeningForVariantChange = true;
      }
    }
  }, {
    key: "stopListeningForVariantChange",
    value: function stopListeningForVariantChange() {
      if (this.listeningForVariantChange) {
        this.$el.querySelector('[data-product-form]').removeEventListener('product-variant-switch', this._handleVariantChange);
        this.listeningForVariantChange = false;
      }
    }
  },{
    key: "unload",
    value: function unload() {
      this.stopListeningForVariantChange();
    }
  }, {
    key: "_handleVariantChange",
    value: function _handleVariantChange(event) {
      var data = event.detail;
      this._onVariantChange(data);
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(_ref2, force) {
      var _this = this,
          isProduct = _ref2.isProduct;
      if (_ref2.firstLoad == true) {
        this.vLoad = [];
        VariantLoad(this.section, this.$el.querySelector('[data-product-form]'), _ref2.product, this.vLoad, this.section.id);
        return;
      } else if (isProduct && !isProduct(this.data.product_info)) {
        return;
      }
      if (theme.thumbID) {        
        var lastFocusedElement = theme.thumbVAR,
            lastFocusedElementID = theme.thumbVAR.dataset.variantId;
        if (_ref2.theme_pJ.variant_type == 'radio') {
          var lastFocusedElementIDFocus = theme.thumbVAR.id;
        } else {
          var lastFocusedElementIDFocus = theme.thumbVAR.parentElement.id
        }
        theme.thumbID = false;
      } else {
        if (_ref2.theme_pJ.variant_type == 'radio') {
          var lastFocusedElement = _ref2.firstLoad.target,
              lastFocusedElementID = _ref2.firstLoad.target.dataset.variantId;
        } else {
          var lastFocusedElement = _ref2.firstLoad.target.options[_ref2.firstLoad.target.selectedIndex],
              lastFocusedElementID = _ref2.firstLoad.target.options[_ref2.firstLoad.target.selectedIndex].dataset.variantId;
        }
        var lastFocusedElementIDFocus = _ref2.firstLoad.target.id
      }
      if (lastFocusedElement.hasAttribute('data-product-url')) {
        window.location.href = lastFocusedElement.dataset.productUrl;
        return;
      }
      if (this.productGallery) {
        this.productGallery.selectMediaByVariant(lastFocusedElement);
      }
      var vMF = this.$el.querySelectorAll('.variant_reload');
      const targetId = lastFocusedElementID;
      const foundObject = this.vLoad.filter(e => e.id === targetId);
      if (foundObject.length > 0) {      
        vMF.forEach(function(v,i) {
            v.innerHTML = foundObject[0].blocks[i].innerHTML;
        });
        VariantLoad(this.section, this.$el.querySelector('[data-product-form]'), this.data.product_info, this.vLoad, this.section.id);
      } else {
        return;
      }
      if (this.$el.querySelector('[data-product-form] [data-product-options]') && lastFocusedElementIDFocus) {
        document.getElementById(lastFocusedElementIDFocus).focus();
      }
      Cart(this.$el)
      Quantity(this.$el);
      if (this.$el.querySelector('.product-single__store-availability-container')) {
        StoreAvailabilityLoad(_ref2.theme_pJ, this.$el);
      }
      Tooltip(this.$el);
      theme.time = 0;
    }
  }]);
  return ProductDetails;
}();

function ProductLoad_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductLoad_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductLoad_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductLoad_defineProperties(Constructor, staticProps); return Constructor; }
var ProductLoad = function () {
  function ProductLoad(section) {
  var pID = document.getElementById('product-select-' + section.id);
  this.$el = section.el;
  this.section = section;
  this.section.data = JSON.parse(document.getElementById('ProductJson-' + section.id).innerHTML);
  if (this.section.data.product_info === null) {
    return;
  }
  this.productDetails = new ProductDetails({
    $el: this.$el,
    section: section,
    theme_pJ: this.section.data
  });
  function RecV() {
    const pA = [];
    let jR,
        jRA,
        jRAS;
    const nP = 16;
    const pD = {      
      pID: this.section.data.product_info.id,
      pIT: this.section.data.product_info.title
    } 
    pA.push(pD);
    const cpT = pD.pID; 
    const pDS = JSON.stringify(pA);
    const lD = localStorage.getItem('rVP');
    if(lD == null) { 
      localStorage.setItem('rVP', pDS);
    } else if (lD != null ) {
      const opD = localStorage.getItem('rVP');
      const cpD = (opD.match(/pID/g) || []).length;
      const rP =  opD.includes(cpT);
      if (cpD < nP && rP == false) {
        jR = JSON.parse(opD);
        jRA = jR.concat(pA);
        jRAS = JSON.stringify(jRA);
        localStorage.setItem('rVP', jRAS);
      }
      else if (cpD >= nP && rP == false) {
        jR = JSON.parse(opD);
        jR.shift();
        jRA = jR.concat(pA);
        jRA =  JSON.stringify(jRA);
        localStorage.setItem('rVP', jRA);
      }
    }
  }
  RecV();  
  }
  ProductLoad_createClass(ProductLoad, [{
    key: "onSectionMessage",
    value: function onSectionMessage(name, data) {
      if (this.productDetails.productGallery) {
        this.productDetails.productGallery.onSectionMessage(name, data);
      }
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      if (this.productDetails) this.productDetails.unload();
    }
  }]);
  return ProductLoad;
}();

document.addEventListener('Section:Loaded', function(event){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  let sectionId = sectionContainer.dataset.sectionId;
  if(sectionType === 'product-alt'){
    const s = {
      el: sectionContainer, 
      id: sectionId, 
      type: sectionType
    };
    ProductLoad(s);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  let sectionId = sectionContainer.dataset.sectionId;
  if(sectionType === 'product_page' || sectionType === 'product-alt' && !sectionContainer.classList.contains('ignore')){
    const s = {
      el: sectionContainer, 
      id: sectionId, 
      type: sectionType
    };
    ProductLoad(s);
    sectionContainer.classList.add('ignore');
  }
})

theme.Product = (function() {
  function Product(section) {
    var sectionId = section.getAttribute('data-section-id'),
        type = section.getAttribute('data-carousel-type');
    if (type == 'section') {
      Tabs(section);
      if (Shopify.designMode) {        
        var Carousel = document.getElementById('tabs-carousel-' + sectionId);
        Product.prototype.onBlockSelect = function(ev) {
          var tI = section.querySelectorAll('.tabs-id-' + sectionId + ' a'),
              tB = section.querySelectorAll('.tab-body-id-' + sectionId),
              tT = ev.target,
              tH = section.querySelector(ev.target.getAttribute('href'));
          if (tI) {
            tI.forEach(function(t) {
              t.classList.remove('first');
              t.setAttribute('tabindex','-1');
              t.removeAttribute('aria-selected');
            });
            tB.forEach(function(t) {
              t.classList.add('hide');
              var s = t.querySelector('.product-loop[data-glider="loaded"]');
              if (s) {
                s.setAttribute('data-glider', 'ignore');
              }
            });
          }
          tT.classList.add('first');
          tT.removeAttribute('tabindex');
          tT.setAttribute('aria-selected','true');      
          tH.classList.remove('hide');
          var loop = tH.querySelector('.product-loop[data-glider="unloaded"]');
          if (loop) {
            loop.setAttribute('data-glider', 'loaded');
            if (loop.getAttribute('data-glider') === 'loaded') {
              Sliders(section);
            }
          }
          var tC = document.getElementById('tabs-carousel-' + sectionId);
          if (tC) {        
            var mSI = parseInt(ev.target.getAttribute('data-gslide'));
            Glider(tC).scrollItem(parseInt(mSI));
          }
        };
      }
    } 
  }
  return Product;
})();